<mat-dialog-content class="accent-color dialogue-content blood-dialogue">
  <div class="patient-history mat-typography">
    <div class="row">
      <div class="large-12 equalize outer-card">
        <div class="description">
          <div class="">
            <p style="text-align:center; display: block; margin: 0 auto;">
              Oops!
            </p>
          </div>
        </div>
        <section class="response medication inputs blood">
          <p style="text-align:center; margin-top: 20px;">
            {{h1text}}. {{h2text}}.
          </p>
        </section>
        <section class="actions">
          <button (click)="abortActiveSession()" mat-raised-button color="primary"
            class="action mat-button mat-raised-button mat-primary cancel"
            [mat-dialog-close]="true">{{btn1text}}</button>
          <button class="action mat-button mat-raised-button mat-primary success" [mat-dialog-close]="true">{{btn2text}}
          </button>
        </section>
      </div>
    </div>
  </div>
</mat-dialog-content>
